import { motion } from "framer-motion";
import { Send, Search, Sparkles, Zap } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export function HowItWorks() {
  const { t } = useLanguage();

  const steps = [
    { icon: Send, step: "01", title: t.howItWorks.step1Title, description: t.howItWorks.step1Desc },
    { icon: Search, step: "02", title: t.howItWorks.step2Title, description: t.howItWorks.step2Desc },
    { icon: Sparkles, step: "03", title: t.howItWorks.step3Title, description: t.howItWorks.step3Desc },
    { icon: Zap, step: "04", title: t.howItWorks.step4Title, description: t.howItWorks.step4Desc },
  ];

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-dark" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 rounded-full blur-[100px]" />

      <div className="container mx-auto px-4 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-2xl mx-auto mb-16"
        >
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">
            {t.howItWorks.title} <span className="text-gradient-ai">{t.howItWorks.titleBrand}</span> {t.howItWorks.titleEnd}
          </h2>
          <p className="text-muted-foreground text-lg">
            {t.howItWorks.subtitle}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => {
            const Icon = step.icon;
            return (
              <motion.div
                key={step.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.15 }}
                className="relative"
              >
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-12 left-[60%] w-full h-px bg-gradient-to-r from-accent/50 to-transparent" />
                )}
                <div className="text-center">
                  <div className="relative inline-flex mb-6">
                    <div className="w-24 h-24 rounded-2xl bg-glass border border-white/10 flex items-center justify-center">
                      <Icon className="w-10 h-10 text-accent" />
                    </div>
                    <span className="absolute -top-2 -right-2 w-8 h-8 rounded-lg bg-gradient-ai flex items-center justify-center text-sm font-bold text-accent-foreground">
                      {step.step}
                    </span>
                  </div>
                  <h3 className="font-display font-semibold text-xl mb-3 text-foreground">
                    {step.title}
                  </h3>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
